// refresh.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RefreshService {
    constructor(private router: Router) { }


    async refreshAll(): Promise<void> {
        try {
            const current = this.router.url;

            await this.router.navigateByUrl('/', { skipLocationChange: true });
            await this.router.navigateByUrl(current);
            await firstValueFrom(timer(150));
            return;
        } catch (err) {
            console.warn('[RefreshService] soft refresh failed, doing hard reload', err);
            window.location.reload();
        }
    }
}
